// @ts-ignore
import React from "react";

import ImageChecklistSide from "@/patterns/image-checklist-side";

const Automation = () => {
    const title = "Automation";
    const listItems = [
        <>
            <strong>Drag and drop automation:</strong> Focus on the important
            things. Let automation do the rest. Powerful, yet simple - Jira
            automation is actually fun to use.
        </>,
        <>
            <strong>Auto-assign issues:</strong> When an issue is raised without
            an assignee, auto-assign to whoever created it so nothing falls
            through the cracks.
        </>,
        <>
            <strong>Sync work:</strong> When an epic is marked as ‘done’ move
            all of its stories to ‘done’ also.
        </>,
        <>
            <strong>Daily Slack summary:</strong> Send a daily Slack message
            with a list of issues still open in the Sprint.
        </>,
        <>
            <strong>Auto-close old support issues:</strong> If a customer has
            not responded to an issue in 5 days, close the issue and leave a
            comment.
        </>
    ];
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:61848582-efe5-4b31-9ff0-de864d004900/JSW_Automation.png?cdnVersion=ecc";
    const imageAlt = "Jira automation";

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
        />
    );
};

export default Automation;
